import { render, staticRenderFns } from "./fwb.vue?vue&type=template&id=05d4455c&scoped=true"
import script from "./fwb.vue?vue&type=script&lang=js"
export * from "./fwb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4455c",
  null
  
)

export default component.exports